module.exports = __webpack_public_path__ + "assets/img/27a4620172eeadc0761abff0daf6ccf9.svg";